<template>
  <div class="d-flex flex flex-column step-container">
    <div class="logo">
      <img class="mt-5 ml-5" width="140px" :src="urlLogoInverse" :alt="workspaceName" />
    </div>
    <div class="mt-auto mb-auto ml-8">
      <transition name="slide-fade" mode="out-in">
        <div class="step-title mb-10 ml-1" :key="actualStep">{{ displayStep }} de {{ totalSteps }} passos</div>
      </transition>
      <div class="steppers">
        <transition name="slide-fade" mode="out-in">
          <CadastroStepCard :step="getStepByNumber(actualStep)" :active="true" :key="actualStep" />
        </transition>
        <transition name="slide-fade" mode="out-in">
          <CadastroStepCard
            v-if="$route.name !== 'cadastro-sucesso' && getNextStepNumber()"
            :step="getStepByNumber(getNextStepNumber())"
            class="mb-5"
            :key="actualStep + 1" />
        </transition>
      </div>
    </div>
    <div class="back-button" v-if="this.actualStep < 7" @click="$router.back()">
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" size="50" color="primary">mdi-chevron-left</v-icon>
        </template>
        <span>Página anterior</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import CadastroStepCard from '@/modules/Cadastro/steps/CadastroStepCard'
import { steps } from '@/utils/constants'

export default {
  components: {
    CadastroStepCard,
  },
  data: () => ({
    steps,
  }),
  computed: {
    offsetPixel() {
      return `-${(this.actualStep - 1) * 120}px`
    },
    ...mapState('cadastro', ['actualStep']),
    ...mapGetters('customizacao', ['urlLogoInverse', 'workspaceName', 'skipFaturamentoStep']),
    stepsToShow() {
      return this.skipFaturamentoStep ? this.steps.filter(s => s.number !== 5) : this.steps
    },
    displayStep() {
      const idx = this.stepsToShow.findIndex(s => s.number === this.actualStep)
      return idx >= 0 ? idx + 1 : this.actualStep
    },
    totalSteps() {
      return this.stepsToShow.length
    },
  },
  methods: {
    getStepByNumber(step) {
      return this.stepsToShow.find(item => item.number === step)
    },
    getNextStepNumber() {
      const idx = this.stepsToShow.findIndex(s => s.number === this.actualStep)
      return this.stepsToShow[idx + 1]?.number
    },
  },
}
</script>

<style lang="scss" scoped>
.step-title {
  font-size: 1.3rem;
}

.steppers {
  display: flex;
  flex-direction: column;
  top: 0;
  position: relative;
  transition: top 0.5s;
}

.step-container {
  background-color: var(--v-primary-base) !important;
  height: 100%;
  color: #fff;
  position: fixed;
  width: 25%;
  padding: auto;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.back-button {
  position: absolute;
  top: 0;
  margin-left: 100%;
  margin-top: 10px;
  -webkit-transition: all 100ms ease-in-out;
  transition: all 100ms ease-in-out;
  cursor: pointer;
}

.back-button:hover {
  transform: scale(1.1);
}
</style>
